var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestiIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6384_34748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2282 4.61615C15.2287 4.08151 14.9014 3.59844 14.3974 3.38958L13.421 2.98385C12.5708 2.63125 12.0191 1.81667 12.0201 0.915104C12.0193 0.409896 11.6002 0.000520833 11.0827 0H9.91735C9.39979 0.000520833 8.98041 0.409896 8.97988 0.915104C8.98094 1.81667 8.42897 2.63125 7.579 2.98385L6.60232 3.38958C6.0981 3.59844 5.77102 4.08151 5.77156 4.61615V5.60495H15.2282V4.61615Z",
    fill: "url(#paint0_linear_6384_34748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9511 5.05469H16.5941V6.27187C16.5941 6.6401 16.2884 6.93854 15.9111 6.93854H5.08886C4.71163 6.93854 4.4059 6.6401 4.4059 6.27187V5.05469H2.04888C0.91773 5.05599 0.00133391 5.95052 0 7.05469V27C0.00133391 28.1042 0.91773 28.9987 2.04888 29H18.9511C20.0823 28.9987 20.9989 28.1042 21 27V7.05469C20.9989 5.95052 20.0823 5.05599 18.9511 5.05469ZM3.28515 12.5247H9.24959C9.62682 12.5247 9.93256 12.8232 9.93256 13.1914C9.93256 13.5596 9.62682 13.8581 9.24959 13.8581H3.28515C2.90792 13.8581 2.60219 13.5596 2.60219 13.1914C2.60219 12.8232 2.90792 12.5247 3.28515 12.5247ZM17.7148 23.9948H3.28515C2.90792 23.9948 2.60219 23.6964 2.60219 23.3281C2.60219 22.9599 2.90792 22.6615 3.28515 22.6615H17.7148C18.0921 22.6615 18.3978 22.9599 18.3978 23.3281C18.3978 23.6964 18.0921 23.9948 17.7148 23.9948ZM17.7148 19.1026H3.28515C2.90792 19.1026 2.60219 18.8042 2.60219 18.4359C2.60219 18.0677 2.90792 17.7693 3.28515 17.7693H17.7148C18.0921 17.7693 18.3978 18.0677 18.3978 18.4359C18.3978 18.8042 18.0921 19.1026 17.7148 19.1026Z",
    fill: "url(#paint1_linear_6384_34748)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6384_34748",
    x1: -3.52917,
    y1: 60.175,
    x2: -28.1799,
    y2: 45.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6384_34748",
    x1: -3.52917,
    y1: 60.175,
    x2: -28.1799,
    y2: 45.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6384_34748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestiIcon);
export default __webpack_public_path__ + "static/media/questi_icon.0b47da4e75bc261ffcf15019521c383f.svg";
export { ForwardRef as ReactComponent };